(function ($) {
  'use strict';

  var protoPatch = false;

  function fixDotLi(li, i) {
    var idx = (i !== undefined) ? i : Array.from(li.parentElement.children).indexOf(li);
    li.setAttribute('role', 'tab');
    li.removeAttribute('aria-hidden');
    li.removeAttribute('aria-controls'); // Slick sets aria-controls="navigationN" but no matching ID exists
    if (!li.getAttribute('aria-label')) {
      li.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
    }
  }

  function fixAllDots() {
    document.querySelectorAll('.slick-dots li').forEach(function (li, i) {
      fixDotLi(li, i);
    });
  }

  // Wrap Slick's initADA() prototype so every call — init, reinit, postSlide — auto-fixes dots.
  function patchSlickPrototype(slick) {
    if (protoPatch) return;
    var proto = Object.getPrototypeOf(slick);
    if (!proto || !proto.initADA) return;
    protoPatch = true;
    var origInitADA = proto.initADA;
    proto.initADA = function () {
      origInitADA.call(this);
      if (this.$dots) {
        this.$dots.find('li').each(function (i) { fixDotLi(this, i); });
      }
    };
  }

  // MutationObserver: catches any role="presentation" set on slick-dots li elements
  // and corrects them as a microtask — covers timing gaps before prototype patch applies.
  var mo = new MutationObserver(function (mutations) {
    var needsFix = false;
    for (var i = 0; i < mutations.length; i++) {
      var el = mutations[i].target;
      if (el.tagName === 'LI' &&
          el.parentElement &&
          el.parentElement.classList.contains('slick-dots') &&
          el.getAttribute('role') === 'presentation') {
        needsFix = true;
        break;
      }
    }
    if (needsFix) fixAllDots();
  });

  function patchSlider(slick) {
    var $el = slick.$slider;
    var total = slick.slideCount;
    var label = $el.data('slick-aria-label') || 'Image slideshow';

    // Fix .slick-track[role="listbox"] — missing accessible name
    $el.find('.slick-track[role="listbox"]').attr('aria-label', label);

    // Fix .slick-slide[role="option"] — missing accessible name
    $el.find('.slick-slide:not(.slick-cloned)[role="option"]').each(function (i) {
      $(this).attr('aria-label', 'Slide ' + (i + 1) + ' of ' + total);
    });

    // Fix aria-hidden-focus — focusable children inside hidden slides
    $el.find('.slick-slide[aria-hidden="true"]')
      .find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
      .attr('tabindex', '-1');
    $el.find('.slick-slide:not([aria-hidden="true"])')
      .find('[tabindex="-1"]')
      .removeAttr('tabindex');

    // Fix SVG arrows — role="img" without <title>
    $el.find('.slick-prev, .slick-next').each(function () {
      var $btn = $(this);
      var $svg = $btn.find('svg[role="img"]');
      if ($svg.length && !$svg.find('title').length) {
        var t = $btn.hasClass('slick-prev') ? 'Previous slide' : 'Next slide';
        $svg.prepend('<title>' + t + '</title>');
      }
    });
  }

  $(document).on('init.slick', function (_e, slick) {
    if (!slick || !slick.$slider) return;
    patchSlickPrototype(slick);
    setTimeout(function () { patchSlider(slick); }, 0);
  });

  $(document).on('afterChange.slick', function (_e, slick) {
    if (slick && slick.$slider) patchSlider(slick);
  });

  $(function () {
    // Start observer before safety-net scan so nothing is missed
    mo.observe(document.body, { attributes: true, attributeFilter: ['role'], subtree: true });

    $('.slick-initialized').each(function () {
      try {
        var s = $(this).slick('getSlick');
        if (s) {
          patchSlickPrototype(s);
          setTimeout(function () { patchSlider(s); }, 0);
        }
      } catch (err) {}
    });
  });

}(jQuery));
